import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { OlxAdvertService } from '../../../../services/olx-advert.service';
import { BaseService } from '../../../../services/base.service';
import { map, Observable } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { IParams } from '../../../../model/http';
import { ChannelService } from '../../../../services/channel.service';
import { CHANNEL_STATUS, CHANNEL_TYPE } from '../../../../enum/constants';

@Component({
  selector: 'app-my-packets',
  templateUrl: './my-packets.component.html',
  styleUrls: ['./my-packets.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class MyPacketsComponent implements OnInit {
  packets: any[] = [];
  public items: any[] = [];
  public itemsRequest: any;
  public currentChannelId: any = null;
  public isLoader: boolean = false;
  private channelQuery = this.activatedRoute.snapshot.queryParams['channel'];

  constructor(
    private readonly olxAdvertService: OlxAdvertService,
    public readonly baseService: BaseService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly channelService: ChannelService,
  ) {}

  public filterStatuses = [
    { name: 'olx.packages.active', value: 'active', color: 'green', active: true, selected: false },
    { name: 'olx.packages.inactive', value: 'inactive', color: 'red', active: true, selected: false },
  ];

  dataSource$: Observable<any> = this.olxAdvertService.itemsPackets$.pipe(
    map((data) => {
      return {
        items: data.data,
        pageSize: 10,
        pageIndex: data.page ? data.page : 0,
        length: data.total || 0,
      };
    }),
  );

  getItemsWithUpdatedParams(params: IParams, isLoader = false) {
    if (this.itemsRequest) {
      this.itemsRequest.unsubscribe();
    }
    this.isLoader = isLoader;
    this.itemsRequest = this.olxAdvertService.setQueryPacketsParams(this.currentChannelId, params).subscribe({
      next: () => {
        this.isLoader = false;
      },
      error: () => {
        this.isLoader = false;
      },
    });
  }

  onValueChange(event: any) {
    this.currentChannelId = event?.id;
    this.baseService.setQuery('channel', this.currentChannelId);
    this.getItemsWithUpdatedParams({}, true);
  }

  onFilterChange(item: any) {
    if (item.selected) {
      this.filterStatuses.forEach((v) => (v.active = true));
      this.filterStatuses.forEach((v) => (v.selected = false));
      this.getItemsWithUpdatedParams({ page: 1, filters: '' }, true);
    } else {
      this.filterStatuses.forEach((v) => (v.active = false));
      this.filterStatuses.forEach((v) => (v.selected = false));
      item.active = true;
      item.selected = true;
      this.getItemsWithUpdatedParams({ page: 1, filters: item.value }, true);
    }
  }

  ngOnInit() {
    this.isLoader = true;
    this.channelService.getChannels({ scope: 'apps', types: [CHANNEL_TYPE.OLX], status: CHANNEL_STATUS.CONNECTED }).subscribe({
      next: (channels: any[]) => {
        this.items = channels;
        const data = {
          id: this.channelQuery || channels[0]?.id || null,
        };
        this.onValueChange(data);
      },
      error: () => {
        this.isLoader = false;
      },
    });
  }

  onPaginationChange(paginationDetails: any) {
    const { pageIndex } = paginationDetails;
    const page = pageIndex;
    this.getItemsWithUpdatedParams({ page }, true);
  }
}
